import styled from 'styled-components';
import { theme } from '../../../constants/theme.mjs';
import '../../Avatar/index.mjs';
import '../../Button/index.mjs';
import { Button } from '../../Button/Button.mjs';
import { Avatar as Avatar$1 } from '../../Avatar/Avatar.mjs';
"use strict";
const ButtonWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  row-gap: 16px;
`;
const CustomLinkBtn = styled(Button)`
  line-height: 1;
  display: flex;
  align-items: center;
  min-height: auto;
  color: ${theme.colors.menu.text.light};

  &:hover {
    color: ${theme.colors.black50};
  }
`;
const CustomButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Avatar = styled(Avatar$1)``;
const Name = styled.p`
  margin: 0;
  font-size: ${theme.font.size16};
  line-height: ${theme.lineHeight.size24};
  color: ${theme.colors.black85};
  font-weight: bold;
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
const Email = styled.p`
  margin: 0;
  font-size: ${theme.font.size12};
  line-height: ${theme.lineHeight.size20};
  color: ${theme.colors.black65};
`;
const NameWrap = styled.div`
  position: relative;
`;
const NamePopover = styled.div`
  display: ${({
  $show
}) => $show ? "block" : "none"};
  word-break: break-all;
  position: absolute;
  overflow: auto;
  font-size: ${theme.font.size14};
  color: ${theme.colors.black85};
  padding: 12px;
  background-color: ${theme.colors.white};
  border-radius: 4px;
  box-shadow: 0 12px 48px rgb(0 0 0 / 0.15);
`;
const Frame = styled.div`
  border-radius: 6px;
  padding: 20px;
  background: ${theme.colors.white};
  display: flex;
  flex-direction: column;
  align-items: center;

  /* Vertical spacing */
  ${Avatar} + ${NameWrap} {
    margin-top: 12px;
  }

  ${Email} + ${ButtonWrap} {
    margin-top: 24px;
  }
`;
export { Avatar, ButtonWrap, CustomButton, CustomLinkBtn, Email, Frame, Name, NamePopover, NameWrap };
//# sourceMappingURL=AccountFrame.styles.mjs.map
